<template>
  <el-table-column v-if='children && children.length' v-bind='col' :label='t(col.label)'>
    <template slot='header' slot-scope='scope'>
      <component v-if='headerSlot' :is='headerSlot' :scope='scope' :col='col'></component>
      <span v-else> {{ t(col.label) }} </span>
    </template>
    <hs-table-column
      v-for='(childColumn, i) in children'
      :key='i'
      :col='childColumn'
    ></hs-table-column>
  </el-table-column>

  <el-table-column v-else-if='component' v-bind='col' :label='t(col.label)'>
    <template slot='header' slot-scope='scope'>
      <component v-if='headerSlot' :is='headerSlot' :scope='scope' :col='col'></component>
      <span v-else> {{ t(col.label) }} </span>
    </template>
    <template slot-scope='scope'>
      <component :is='component' :row='scope.row' v-on='col.handlers' :col="col"></component>
    </template>
  </el-table-column>

  <el-table-column v-else-if='type === "operation"' v-bind='col' :label='t(col.label)'>
    <template slot='header' slot-scope='scope'>
      <component v-if='headerSlot' :is='headerSlot' :scope='scope' :col='col'></component>
      <span v-else> {{ t(col.label) }} </span>
    </template>
    <template slot-scope='scope'>
      <el-button
        type='text'
        v-for='(btn, i) in (typeof col.btns === "function" ? col.btns(scope.row, scope.$index) : col.btns)'
        :key='i'
        @click='btn.handler(scope.row, scope.$index)'
        v-bind='btn.props'
      >{{ t(btn.label) }}</el-button>
    </template>
  </el-table-column>

  <el-table-column v-else v-bind='col' :label='t(col.label)'>
    <template slot='header' slot-scope='scope'>
      <component v-if='headerSlot' :is='headerSlot' :scope='scope' :col='col'></component>
      <span v-else> {{ t(col.label) }} </span>
    </template>
  </el-table-column>
</template>

<script>
import Locale from '../../mixins/locale'

export default {
  name: 'HsTableColumn',
  mixins: [Locale],
  props: {
    col: Object
  },
  data() {
    const { type, headerSlot, component, children, ...props } = this.col;
    return {
      props,
      component,
      children,
      type,
      headerSlot,
    }
  }
}
</script>
